export const lightTokens = {
    "color": {
      "white": "#ffffff",
      "black": "#000000",
      "blue": {
        "100": "#eaf2fd",
        "200": "#a3c7f6",
        "300": "#76abf1",
        "400": "#488fed",
        "500": "#1a73e8",
        "600": "#155cba",
        "700": "#10458b",
        "800": "#0a2e5d",
        "900": "#05172e",
        "base": "#1a73e8",
        "light": "#eaf2fd",
        "dark": "#155cba",
        "faded": "#1a73e880"
      },
      "indigo": {
        "100": "#f1dbf9",
        "200": "#e3b8f3",
        "300": "#d694ed",
        "400": "#c871e7",
        "500": "#BA4DE1",
        "600": "#953eb4",
        "700": "#702e87",
        "800": "#4a1f5a",
        "900": "#250f2d",
        "base": "#BA4DE1",
        "light": "#f1dbf9",
        "dark": "#702e87"
      },
      "purple": {
        "100": "#e2d9f3",
        "200": "#c5b3e6",
        "300": "#a98eda",
        "400": "#8c68cd",
        "500": "#6f42c1",
        "600": "#59359a",
        "700": "#432874",
        "800": "#2c1a4d",
        "900": "#160d27",
        "base": "#6f42c1",
        "light": "#e2d9f3",
        "dark": "#432874"
      },
      "pink": {
        "100": "#f7d6e6",
        "200": "#efadce",
        "300": "#e685b5",
        "400": "#de5c9d",
        "500": "#d63384",
        "600": "#ab296a",
        "700": "#801f4f",
        "800": "#561435",
        "900": "#2b0a1a",
        "base": "#d63384",
        "light": "#f7d6e6",
        "dark": "#801f4f"
      },
      "red": {
        "100": "#f8d8d5",
        "200": "#f0b0aa",
        "300": "#e98980",
        "400": "#e16155",
        "500": "#da3a2b",
        "600": "#ae2e22",
        "700": "#83231a",
        "800": "#571711",
        "900": "#2c0c09",
        "base": "#da3a2b",
        "light": "#f8d8d5",
        "dark": "#83231a"
      },
      "orange": {
        "100": "#ffe5d0",
        "200": "#fecba1",
        "300": "#feb272",
        "400": "#fd9843",
        "500": "#fd7e14",
        "600": "#ca6510",
        "700": "#984c0c",
        "800": "#653208",
        "900": "#331904",
        "base": "#fd7e14",
        "light": "#ffe5d0",
        "dark": "#984c0c"
      },
      "yellow": {
        "100": "#fff1da",
        "200": "#ffe3b5",
        "300": "#ffd590",
        "400": "#ffc76b",
        "500": "#ffb946",
        "600": "#cc9438",
        "700": "#996f2a",
        "800": "#664a1c",
        "900": "#33250e",
        "base": "#ffb946",
        "light": "#fff1da",
        "dark": "#664a1c"
      },
      "green": {
        "100": "#d3eddf",
        "200": "#a7dcbf",
        "300": "#7aca9f",
        "400": "#4eb97f",
        "500": "#22a75f",
        "600": "#1b864c",
        "700": "#146439",
        "800": "#0e4326",
        "900": "#072113",
        "base": "#22a75f",
        "light": "#d3eddf",
        "dark": "#0e4326"
      },
      "teal": {
        "100": "#d1ecf1",
        "200": "#a2dae3",
        "300": "#74c7d4",
        "400": "#45b5c6",
        "500": "#17A2B8",
        "600": "#128293",
        "700": "#0e616e",
        "800": "#09414a",
        "900": "#052025",
        "base": "#17A2B8",
        "light": "#d1ecf1",
        "dark": "#0e616e"
      },
      "cyan": {
        "100": "#cff4fc",
        "200": "#9eeaf9",
        "300": "#6edff6",
        "400": "#3dd5f3",
        "500": "#0dcaf0",
        "600": "#0aa2c0",
        "700": "#087990",
        "800": "#055160",
        "900": "#032830",
        "base": "#0dcaf0",
        "light": "#cff4fc",
        "dark": "#087990"
      },
      "gray": {
        "100": "#f6f8fa",
        "200": "#e7eef4",
        "300": "#d3d8e0",
        "400": "#c0c9d5",
        "500": "#69788B",
        "600": "#5e6d82",
        "700": "#455469",
        "800": "#324054",
        "900": "#23282e",
        "light": "#f6f8fa",
        "dark": "#455469"
      },
      "common": {
        "bg": {
          "base": "#ffffff",
          "secondary": "#f6f8fa"
        },
        "border": "#e7eef4",
        "border-dark": "#d3d8e0",
        "light": "#f6f8fa",
        "dark": "#324054"
      },
      "font": {
        "base": "#23282e",
        "light": "#5e6d82",
        "soft": "#5e6d82",
        "reverse": "#ffffff",
        "link": "#1a73e8",
        "link.hover": "#155cba",
        "error": "#da3a2b",
        "label": "#23282e"
      },
      "primary": "#1a73e8",
      "primary-light": "#eaf2fd",
      "primary-dark": "#155cba",
      "success": "#22a75f",
      "success-light": "#d3eddf",
      "success-dark": "#0e4326",
      "critical": "#da3a2b",
      "critical-light": "#f8d8d5",
      "critical-dark": "#83231a",
      "warning": "#ffb946",
      "warning-light": "#fff1da",
      "warning-dark": "#664a1c",
      "info": "#1a73e8",
      "info-light": "#eaf2fd",
      "info-dark": "#155cba",
      "alert": {
        "text": "#455469",
        "success": {
          "bg": "#d3eddf"
        },
        "critical": {
          "bg": "#f8d8d5"
        },
        "warning": {
          "bg": "#fff1da"
        },
        "info": {
          "bg": "#eaf2fd"
        }
      },
      "avatar": {
        "blue": {
          "bg": "#eaf2fd",
          "text": "#155cba"
        },
        "orange": {
          "bg": "#ffe5d0",
          "text": "#984c0c"
        },
        "green": {
          "bg": "#d3eddf",
          "text": "#0e4326"
        },
        "purple": {
          "bg": "#e2d9f3",
          "text": "#432874"
        },
        "pink": {
          "bg": "#f7d6e6",
          "text": "#801f4f"
        },
        "red": {
          "bg": "#f8d8d5",
          "text": "#83231a"
        },
        "yellow": {
          "bg": "#fff1da",
          "text": "#664a1c"
        },
        "teal": {
          "bg": "#d1ecf1",
          "text": "#0e616e"
        },
        "cyan": {
          "bg": "#cff4fc",
          "text": "#087990"
        },
        "indigo": {
          "bg": "#f1dbf9",
          "text": "#702e87"
        }
      },
      "button": {
        "primary": {
          "text": "#ffffff",
          "bg": "#1a73e8",
          "border": "#1a73e8",
          "hover": {
            "bg": "#1462c8",
            "border": "#1462c8"
          },
          "press": "#135cbc"
        },
        "default": {
          "text": "#1a73e8",
          "bg": "#00000000",
          "border": "#1a73e8",
          "hover": {
            "bg": "#1a73e8",
            "text": "#ffffff"
          }
        },
        "critical": {
          "text": "#ffffff",
          "bg": "#da3a2b",
          "border": "#da3a2b",
          "hover": "#be2f21",
          "press": "#b32c1f"
        }
      },
      "color-block-button": {
        "unconfigured": "#e7eef4"
      },
      "checkbox": {
        "bg": "#ffffff",
        "border": "#e7eef4",
        "readonly-bg": "#f6f8fa",
        "readonly-checked-bg": "#1a73e880"
      },
      "icon-button": {
        "fill": "#324054"
      },
      "input": {
        "text": "#23282e",
        "bg": "#ffffff",
        "border": "#69788B",
        "readonly-bg": "#f6f8fa"
      },
      "nav-bar": {
        "border": "#00000000"
      },
      "nav-bar-item": {
        "unselected": {
          "text": "#455469"
        },
        "hover": {
          "bg": "#f6f8fa"
        },
        "selected": {
          "text": "#155cba",
          "bg": "#eaf2fd"
        }
      },
      "table-row": {
        "hover": {
          "bg": "#f6f8fa"
        },
        "selected": {
          "bg": "#eaf2fd"
        }
      },
      "tooltip": {
        "container": {
          "bg": "#23282e"
        }
      }
    },
    "size": {
      "alert": {
        "icon": 18
      },
      "avatar": {
        "sm": 24,
        "md": 32,
        "lg": 72,
        "xl": 104
      },
      "badge": 12,
      "input": {
        "height": 50
      },
      "modal": {
        "sm": 300,
        "md": 500,
        "lg": 800,
        "xl": 1140
      },
      "control": {
        "height": 50
      }
    },
    "font-size": {
      "avatar": {
        "sm": 9.600000000000001,
        "md": 12.8,
        "lg": 28.8,
        "xl": 41.6
      },
      "button": {
        "small": 13.25
      },
      "label": 15,
      "nav-bar-item": 14,
      "h6": 12,
      "h5": 15,
      "h4": 18.75,
      "h3": 22.5,
      "h2": 26.25,
      "h1": 33.75,
      "base": 15,
      "small": 14,
      "tiny": 12
    },
    "font-weight": {
      "badge": 600
    },
    "spacing": {
      "badge": {
        "padding-x": 8,
        "padding-y": 4
      },
      "button": {
        "padding-x": 20,
        "padding-y": 12
      },
      "buttonSmall": {
        "padding-x": 8,
        "padding-y": 4
      },
      "card": {
        "shadow": {
          "y": '1px',
          "blur": '3px'
                }
      },
      "checkbox": {
        "label-gap": 16
      },
      "field": {
        "gap": 4
      },
      "input": {
        "padding-x": 12
      },
      "container": {
        "padding": 8
      },
      "modal": {
        "shadow": {
          "y": 8,
          "spread": 16
        }
      },
      "xl": 48,
      "lg": 24,
      "md-l": 20,
      "md": 16,
      "md-s": 12,
      "sm": 8,
      "xs": 4
    },
    "radius": {
      "button": {
        "radius": 50
      },
      "checkbox": {
        "radius": 4
      },
      "input": 4,
      "md": 4,
      "lg": 8,
      "xl": 16
    },
    "line-height": {
      "base": 1.6
    }
  }
  